export const useJsonLd = () => {
  const config = useRuntimeConfig().public
  const BRAND_NAME = config.BRAND_NAME ?? '86BET'
  const SITE_DOMAIN = config?.SITE_DOMAIN ?? 'https://86bet.net/'

  const jsonLdData = {
    '@context': 'https://schema.org',
    '@type': 'Casino',
    '@id': SITE_DOMAIN,
    name: BRAND_NAME,
    alternateName: 'Title của 86BET',
    url: SITE_DOMAIN,
    logo: 'https://86bet.net/logo.png',
    image: 'https://86bet.net/logo.png',
    description: 'Metades 86bet',
    telephone: '09412205910',
    priceRange: '10000VND-100000000VND',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '203 Trần Huy Liệu, Phường 8',
      addressLocality: 'Phú Nhuận',
      addressRegion: 'Hồ Chí Minh',
      postalCode: '700000',
      addressCountry: {
        '@type': 'Country',
        name: 'VN',
      },
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 10.7978603,
      longitude: 106.674932,
    },
    hasMap: 'https://maps.app.goo.gl/b2iASbwzactvphRP9',
    founder: {
      '@type': 'Person',
      name: 'Author 86bet.net',
    },
    foundingDate: '2023-06-15',
    areaServed: {
      '@type': 'Country',
      name: 'Vietnam',
    },
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '4.6',
      reviewCount: '1345',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '09412205910',
      contactType: 'customer support',
      availableLanguage: ['Vietnamese', 'English'],
    },
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: [
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
          'Sunday',
        ],
        opens: '00:00',
        closes: '23:59',
      },
    ],
    sameAs: [
      'https://facebook.com/86bet',
      'https://twitter.com/86bet',
      'https://instagram.com/86bet',
    ],
    makesOffer: [
      {
        '@type': 'Offer',
        name: 'Dịch vụ 86bet 1',
        description: 'Mô tả dịch vụ 1',
        url: `${SITE_DOMAIN}dich-vu-1`,
      },
      {
        '@type': 'Offer',
        name: 'Dịch vụ 86bet 2',
        description: 'Mô tả dịch vụ 2',
        url: `${SITE_DOMAIN}dich-vu-2`,
      },
    ],
  }

  const jsonLdScript = {
    type: 'application/ld+json',
    innerHTML: JSON.stringify(jsonLdData),
  }

  return {
    jsonLdScript,
  }
}
